import React from "react";
import OwlCarousel from "react-owl-carousel2";

const options = {
  margin: 25,
  loop: true,
  nav: false,
  dots: false,
  rewind: true,
  autoplay: true,
  animateIn: "linear",
  animateOut: "linear",
  slideTransition: "linear",
  smartSpeed: 3700,
  autoplayHoverPause: true,
  autorefresh: true,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 2,
    },
    1300: {
      items: 4,
    },
    1600: {
      items: 5,
    },
  },
};

const IstaCarousel = ({
  totalOrder,
  totalOrderPrice,
  todayOrder,
  todayOrderPrice,
}) => {
  return (
    <div className="panel panel-default" style={{ position: "sticky" }}>
      <div
        className="panel-heading"
        style={{
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,
        }}
        role="tab"
        id="headingOne"
      >
        <h4 className="panel-title">
          <a
            style={{
              fontWeight: 400,
              fontSize: 14,
              backgroundColor: "#fff",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
            }}
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            İstatistikler
          </a>
        </h4>
      </div>
      <div
        id="collapseOne"
        className="panel-collapse collapse in show"
        role="tabpanel"
        aria-labelledby="headingOne"
      >
        <div className="panel-body" style={{ textAlign: "center" }}>
          <OwlCarousel options={options}>
            <div className="item">
              <div className="card mb-0">
                <div className="row">
                  <div className="col-4">
                    <div className="feature">
                      <div className="fa-stack fa-lg fa-2x icon bg-success-transparent">
                        <i className="si si-briefcase  fa-stack-1x text-success"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-8">
                    <div className="card-body p-3  d-flex">
                      <div>
                        <p className="text-muted mb-1">Haftalık Toplam</p>
                        <h2 className="mb-0 text-dark">{totalOrderPrice} ₺</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="card mb-0">
                <div className="row">
                  <div className="col-4">
                    <div className="feature">
                      <div className="fa-stack fa-lg fa-2x icon bg-primary-transparent">
                        <i className="si si-drawer fa-stack-1x text-primary"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="card-body p-3  d-flex">
                      <div>
                        <p className="text-muted mb-1">Günlük Toplam</p>
                        <h2 className="mb-0 text-dark">{todayOrderPrice} ₺</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="card mb-0">
                <div className="row">
                  <div className="col-4">
                    <div className="feature">
                      <div className="fa-stack fa-lg fa-2x icon bg-primary-transparent">
                        <i className="si si-layers fa-stack-1x text-primary"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="card-body p-3  d-flex">
                      <div>
                        <p className="text-muted mb-1">
                          Haftalık Sipariş Sayısı
                        </p>
                        <h2 className="mb-0 text-dark">{totalOrder} </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="card mb-0">
                <div className="row">
                  <div className="col-4">
                    <div className="feature">
                      <div className="fa-stack fa-lg fa-2x icon bg-pink-transparent">
                        <i className="si si-layers fa-stack-1x text-pink"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="card-body p-3  d-flex">
                      <div>
                        <p className="text-muted mb-1">Günlük Sipariş Sayısı</p>
                        <h2 className="mb-0 text-dark">{todayOrder}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default IstaCarousel;
